import { render } from "./InputListaSuspensaPreenchimento.vue?vue&type=template&id=8d01d34c"
import script from "./InputListaSuspensaPreenchimento.vue?vue&type=script&lang=js"
export * from "./InputListaSuspensaPreenchimento.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/VisualizarForm/components/InputListaSuspensaPreenchimento.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8d01d34c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8d01d34c', __exports__)) {
    console.log('reload')
    api.reload('8d01d34c', __exports__)
  }
  
  module.hot.accept("./InputListaSuspensaPreenchimento.vue?vue&type=template&id=8d01d34c", () => {
    console.log('re-render')
    api.rerender('8d01d34c', render)
  })

}


export default __exports__